import React, { useEffect, useState } from "react";
import {
  Filter,
  Loader,
  PageHero,
  ProductCard,
  ProductDetailsCard,
} from "../components";
import styled from "styled-components";
import { useDispatch, useSelector } from "react-redux";
import { setFilteredProducts } from "../actions";
import { sortData } from "../helper/filters";

const Products = () => {
  const [isGrid, setIsGrid] = useState(false);
  const [sortType, setSortType] = useState("price_ascending");
  const [isLoading, setIsLoading] = useState(true);
  const { filteredProducts, allProducts } = useSelector(
    (state) => state.products
  );
  const dispatch = useDispatch();

  useEffect(() => {
    const newProducts = sortData(filteredProducts, sortType);
    dispatch(setFilteredProducts(newProducts));
  }, [sortType]);

  useEffect(() => {
    setIsLoading(true);
    setTimeout(() => setIsLoading(false), 400);
  }, [filteredProducts]);

  return (
    <>
      <PageHero title={"products"}></PageHero>
      {!allProducts ? (
        <h2>Error!! No products to display...</h2>
      ) : (
        <>
          <Wrapper>
            <section className="filter-section">
              <Filter sortType={sortType} setSortType={setSortType}></Filter>
            </section>
            <section className="products-section">
              <div className="header">
                <div className="views">
                  <button
                    onClick={() => setIsGrid(true)}
                    className={isGrid ? "active" : ""}
                  >
                    <i className="fas fa-th-large"></i>
                  </button>
                  <button
                    onClick={() => setIsGrid(false)}
                    className={!isGrid ? "active" : ""}
                  >
                    <i className="fas fa-bars"></i>
                  </button>
                </div>
                {window.innerWidth > "350" && (
                  <div className="no-of-products">
                    {isLoading || filteredProducts.length} Products Found
                  </div>
                )}
                <div className="seperator"></div>
                <div className="sort">
                  <p>Sort By </p>
                  <select
                    name="cars"
                    id="cars"
                    onChange={(e) => setSortType(e.target.value)}
                  >
                    <option value="price_ascending">Price (Lowest)</option>
                    <option value="price_descending">Price (Highest)</option>
                    <option value="name_ascending">Name (A-Z)</option>
                    <option value="name_descending">Name (Z-A)</option>
                  </select>
                </div>
              </div>
              {window.innerWidth < "350" && (
                <div className="no-of-products">
                  {filteredProducts.length} Products Found
                </div>
              )}
              {isLoading ? (
                <div className="loading">
                  <Loader></Loader>
                </div>
              ) : (
                <div className={isGrid ? "products-grid" : "products-list"}>
                  {filteredProducts.length !== 0 ? (
                    filteredProducts.map((product) =>
                      isGrid ? (
                        <ProductCard key={product._id} {...product} />
                      ) : (
                        <ProductDetailsCard key={product._id} {...product} />
                      )
                    )
                  ) : (
                    <h2>Sorry, no products to display!!</h2>
                  )}
                </div>
              )}
            </section>
          </Wrapper>
        </>
      )}
    </>
  );
};

export default Products;

const Wrapper = styled.section`
  width: 80vw;
  max-width: 1200px;
  margin: 3em auto;
  display: grid;
  grid-template-columns: 180px 1fr;
  gap: 2em;
  .filter-section {
  }
  .products-section {
    flex: 1;
    > .header {
      margin-bottom: 1em;
      display: flex;
      align-items: center;
      justify-content: space-between;
      > .views {
        display: flex;
        > button {
          background-color: transparent;
          border: none;
          cursor: pointer;
          margin-right: 0.6em;
          > svg {
            font-size: 18px;
            padding: 5px 6px;
            border: 1px solid var(--color-black-1);
            border-radius: 5px;
          }
        }
        .active > svg {
          color: var(--color-white);
          background-color: var(--color-black-1);
        }
      }
      > .no-of-products {
        margin-left: 1em;
      }
      > .seperator {
        margin: 0 1.25em;
        flex: 1;
        height: 1px;
        opacity: 40%;
        background-color: var(--color-black-2);
      }
      > .sort {
      }
    }

    > .products-grid {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      column-gap: 1.5em;
      row-gap: 2.5em;
      flex-wrap: wrap;
      > .product-card {
        width: 100%;
      }
    }
    > .products-list {
      > .product-details-card {
        margin: 2em 0;
      }
    }
  }
  @media screen and (max-width: 990px) {
    > .products-section > .products-grid {
      grid-template-columns: repeat(2, 1fr);
    }
  }
  @media screen and (max-width: 768px) {
    > .products-section > .products-grid {
      grid-template-columns: repeat(1, 1fr);
    }
  }
  @media screen and (max-width: 600px) {
    grid-template-columns: 1fr;
    > .products-section {
      > .header {
        font-size: 0.8em;
        > .views {
          > button {
            > svg {
              font-size: 12px;
              padding: 5px;
            }
          }
        }
      }
    }
  }
`;
